import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { listFavoritePlaces } from './actions'
import { getFavePlacesSorted } from '../../rootReducer'
import './FavoritePlaces.css'
import New from './New'
import Update from './Update'
import All from './All'
import onMount from '../../core/onMount'

const mapDispatchToProps = (dispatch) => {
  return {
    onClick: (place)=> dispatch(push(`/account/favorite-places/${place.token_id}`)),
    dispatch
  }
}

const mapStateToProps = (state) => {
  return {
    // places: Object.values(state.models.places.byId) || [],
    places: getFavePlacesSorted(state)

  }
}


const ConnectedUpdate = connect(mapStateToProps, mapDispatchToProps)(Update)

// const MountedAll = onMount(({dispatch}) => dispatch(listFavoritePlaces()) )(All)

const ConnectedAll = connect(mapStateToProps, mapDispatchToProps)(All)

export default (props)=>
  <Switch>
    <Route exact path={`/account/favorite-places`} component={ConnectedAll}/>
    <Route path={`/account/favorite-places/new`} component={New}/>
    <Route path={`/account/favorite-places/:placeId`} component={ConnectedUpdate}/>
  </Switch>



// WEBPACK FOOTER //
// ./src/account/favorite-places/FavoritePlaces.js